/**
 * Centralized API Configuration
 *
 * This file provides smart API URL detection that automatically uses the same
 * hostname as the frontend with port 5256. This enables seamless testing across
 * different environments without rebuilding the application.
 *
 * Examples:
 * - Frontend on localhost:3001 → API at localhost:5256
 * - Frontend on 192.168.0.194:3001 → API at 192.168.0.194:5256
 * - Frontend on app.example.com → API at app.example.com:5256
 *
 * The REACT_APP_API_URL environment variable can still be used to override
 * the smart detection for special cases.
 */

const getApiUrl = (): string => {
  // Check for environment variable override first
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Safety check for SSR or test environments where window may not be available
  if (typeof window === 'undefined') {
    return 'http://localhost:5256';
  }

  // Smart detection: use same hostname as frontend, port 5256
  const protocol = window.location.protocol; // http: or https:
  const hostname = window.location.hostname;
  const apiPort = '5256';

  return `${protocol}//${hostname}:${apiPort}`;
};

export const API_BASE_URL = getApiUrl();
